module.exports = __webpack_public_path__ + "media/assets/images/NcinoEvault-111721bac2d0f9508f9175ee1353842b.svg";